import { Button, Col, Container, Row } from "react-bootstrap";
import Poster from "../../image/entrePoster.png";
import Doc from "../../docs/Entre.pdf";

export default function EitecEnt() {
    return <>
    <Container fluid>
        <Container>
            <br/>
            <img src={Poster} width="100%"/>
            <br/><br/>
            <Row className="justify-content-center">
                    <Col md="auto" sm="12">
                        <Button href={Doc} target="_blank">Read Brochure <i className="bi bi-arrow-right"></i></Button>
                    </Col>
            </Row>
            <br/><br/>

        </Container>
    </Container>
    </>
}